import { Skeleton } from "antd";
import classNames from "classnames";

// components
import Button from "@/shared/Button";

// assets
import styles from "@/assets/styles/components/Modals/select-campaign-modal.module.scss";


const SelectCampaignModalContentLoading = () => {


  return (
    <div className={classNames(
      styles["locl-select-campaign-modal__content"],
      styles["locl-select-campaign-modal__loading"],
    )}>
      <Skeleton.Input active className={styles["locl-select-campaign-modal__loading__input"]} />
      <div className={styles["locl-select-campaign-modal__campaigns"]}>
        {
          Array.from({ length: 5 }, (_, index) => (
            <Skeleton.Input active className={styles["locl-select-campaign-modal__loading__card"]} key={index} />
          ))
        }
      </div>
      <Button
        to="/"
        className={styles["locl-select-campaign-modal__button"]}
        linkClassName={styles["locl-select-campaign-modal__button__link"]}
        disabled
      >
        Go
      </Button>
    </div>
  );
}

export default SelectCampaignModalContentLoading;
